import { isChunkLoadError } from './chunkLoadError';
import { markAppStale } from './appVersionStore';

/**
 * 最後一道防線：沒被 lazyWithRetry 接住的 chunk 載入失敗，不讓它變成未處理錯誤，改為標記過期。
 *
 * 刻意不監聽 vite:preloadError，更不呼叫它的 preventDefault：Vite 的預載輔助函式在事件被取消時，
 * 會讓失敗的 import() 靜默 resolve 成 undefined（`import().catch(handler)` 的 handler 沒有 rethrow），
 * React.lazy 讀 .default 就會丟出 TypeError、整棵樹白屏。事件放行時 Vite 會把原本的載入錯誤照常丟出，
 * 由 lazyWithRetry、ChunkErrorBoundary 或這裡的 unhandledrejection 接住；而且預載事件在重試成功前
 * 也會觸發，直接當作「已過期」會對瞬斷誤報。
 */
export function installChunkErrorListeners(target: Window = window): () => void {
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
        if (!isChunkLoadError(event.reason)) return;
        event.preventDefault();
        markAppStale();
    };

    target.addEventListener('unhandledrejection', handleUnhandledRejection);
    return () => target.removeEventListener('unhandledrejection', handleUnhandledRejection);
}
